export default __webpack_public_path__ + "static/media/lock.6b2fb794.svg";